/**
 * Holds all global actions such as the Loading Spinner
 */
export default {
  spinner({ commit }, loading) {
    commit('SPINNER_STATE', loading);
  },
};
